import React, { useState } from "react";
import EditBtn from "../../../UI/Button/EditBtn";
import ReactSelectSingle from "../../../UI/Form/Select/ReactSelectSingle";

export const preprocessOptions = [
  {
    value: "原体のまま試験に供した。",
    label: "原体のまま希釈しない。",
  },
  {
    value: "注射用蒸留水で1.0%(w/w)に調製し、試験に供した。",
    label: "注射用蒸留水で1.0%(w/w)に調製し、試験に供する。",
  },
  {
    value: "揮発成分を含むため事前に揮発させ、 試験に供した。",
    label: "揮発成分を含むため事前に揮発させ、試験に供する。",
  },
  {
    value: "試験依頼者より提供された試験品を、 原体のまま試験に供した。",
    label: "試験依頼者より提供された試験品を、 原体のまま試験に供する。",
  },
  {
    value: "試験依頼者にて希釈済の試験品を、 原体のまま試験に供した。",
    label: "試験依頼者にて希釈済の試験品を、 原体のまま試験に供する。",
  },
  {
    value: "原体の状態で直径7mmに切り取り、試験に供した。",
    label: "原体の状態で直径7mmに切り取り、試験に供する。",
  },
  {
    value: "原体の状態でろ紙に塗布、 風乾させ、試験に供した。",
    label: "原体の状態でろ紙に塗布、 風乾させ、試験に供する。",
  },
  {
    value: "白色ワセリンで1.0% (w/w)に調製し、 試験に供した。",
    label: "白色ワセリンで1.0% (w/w)に調製し、 試験に供する。",
  },
  {
    value: "その他",
    label: "その他",
  },
];

function TextField(props) {
  const { value, onChange } = props;

  return (
    <div className="w-full">
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full h-10 border border-[#B3B3B3] bg-white rounded-[10px] !outline-none text-custom-size py-2.5 px-3"
      />
    </div>
  );
}

function PlanTableRow(props) {
  const { onClickEdit, rowData, handleChange, indexNum } = props;
  const [other, setOther] = useState(!preprocessOptions.some(item => item.value === rowData.preprocess));

  return (
    <div className="w-full h-auto flex">
      <div
        className="border border-[#B3B3B3] bg-[#B3B3B3] bg-opacity-[26%] px-0 py-[10px] text-sm"
        style={{
          width: "30%",
          textAlign: rowData.textAlign || "start",
        }}
      >
        <p className="leading-[18px] pl-4 tracking-[1.75px] truncate">
          {rowData.name}
        </p>
      </div>

      {rowData.showInput ? (
        <div className="w-[67%] h-auto">
          <ReactSelectSingle
            id="select-pic"
            value={other ? 'その他' : preprocessOptions.find((item) => item.value === rowData.preprocess)?.label}
            onChange={(newValue) => {
              if (newValue === 'その他') {
                setOther(true);
                handleChange(indexNum, '');
              } else {
                setOther(false);
                handleChange(indexNum, newValue);
              }
            }}
            options={preprocessOptions}
            selectedData={preprocessOptions.find((item) => item.value === rowData.preprocess)}
            height={'40px'}
            isWhite
          />

          {other && (
            <TextField
              InputProps={{
                style: {
                  borderRadius: "10px",
                },
              }}
              value={rowData.preprocess}
              onChange={(newValue) => {
                handleChange(indexNum, newValue)
              }}
              size="small"
            />
          )}
        </div>
      ) : (
        <div
          className="h-full border border-[#B3B3B3] bg-[#B3B3B3] bg-opacity-[26%] px-0 py-[10px] text-sm"
          style={{
            width: "67%",
            textAlign: rowData.textAlign || "start",
          }}
        >
          <p className="leading-[18px] pl-4 tracking-[1.75px] truncate">
            {preprocessOptions.find((item) => item.value === rowData.preprocess)?.label || rowData.preprocess}
          </p>
        </div>
      )}

      {rowData.shouldEdit && (
        <EditBtn
          width="3%"
          style={{ justifyContent: "center" }}
          onClick={() => onClickEdit(indexNum)}
          showInput={rowData.showInput}
        />
      )}
    </div>
  );
}

export default PlanTableRow;
